module.exports = __webpack_public_path__ + "img/talentkeepers.ceff1398.png";